// lib/households.js
//
// The one place BCC knows about the reserved INTERNAL household.
//
// The client portal's Firm Projects board (portal docs/FIRM_PROJECTS_ASM_HANDOFF.md,
// portal sql/50, mirrored here as sql/51) puts every firm-internal project on a
// single reserved households row: id 'hh-firm', name 'Bullogic Internal',
// lifecycle = 'internal'. It shares the households table with real clients, so
// anything in BCC that treats a households row as a client (the CRM household
// list, the pipeline dropdown, the revenue engine, and above all the two-way
// Salesforce sync, which would otherwise create a "Bullogic Internal" Account)
// has to skip it. This helper is that rule; the portal carries an identical copy.
//
// Pure module on purpose: no Node or DB imports, so it is safe to import from
// api/*, lib/*, src/revenue/*.mjs (which also runs under Node scripts) and the
// browser bundle alike.

export const INTERNAL_HOUSEHOLD_ID = 'hh-firm';

// Accepts a household id string, or any row-like object carrying `id` /
// `household_id` / `householdId` and optionally `lifecycle`. Either signal
// (the lifecycle or the reserved id) marks it internal, so a caller that only
// has an id in hand still gets the right answer.
export function isInternalHousehold(h) {
  if (h == null) return false;
  if (typeof h === 'string') return h === INTERNAL_HOUSEHOLD_ID;
  const id = h.id ?? h.household_id ?? h.householdId ?? null;
  return h.lifecycle === 'internal' || id === INTERNAL_HOUSEHOLD_ID;
}
